@if (form && employee && (form.visible || isPreview || employee.tester)) {
  <div class="card mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col-auto px-3">
          <img alt="rbb" class="d-inline-block align-top" src="https://tools.rbb-online.de/template/v4/images/rbb.svg"
               style="width: 100px">
        </div>
        <div class="col ">
          <h4 class="text-secondary pt-2">{{form.name}} @if (isPreview) {(Vorschau)}</h4>
        </div>
        <div class="col text-end text-darkgray">
          <span class="fw-bold">{{form.orgUnitType === OrgUnitType.MAIN_DEPARTMENT ? 'Hauptabteilung' : 'Abteilung'}} {{form.orgUnitName}}</span><br>
          @if (form.contactEmail !== 'support@rbb-online.de' || form.contactTelephone !== '44555') {
            <small>
              inhaltliche Fragen - @if (form.contactTelephone) {{{form.contactTelephone}} / }<a href="mailto:{{form.contactEmail}}?subject=Formular: {{form.name}}">{{form.contactEmail}}</a><br>
              technische Probleme - 44555 / <a href="mailto:support@rbb-online.de?subject=Formular: {{form.name}}">support&#64;rbb-online.de</a>
            </small>
          } @else {
            <small>Fragen und Probleme - 44555 / <a href="mailto:support@rbb-online.de?subject=Formular: {{form.name}}">support&#64;rbb-online.de</a></small>
          }
        </div>
      </div>
      <hr>
      @if (form.owners?.includes(webAuthService.authUser?.username ?? '')) {
        <p class="small text-secondary mb-5">Link zu diesem Formular: <a href="{{webUrl}}/tag/{{form.tag}}" class="fw-light text-secondary" target="_blank">{{webUrl}}/tag/{{form.tag}}</a></p>
      }
      @if (!isPreview) {
        <rbb-steps [steps]="steps" [current]="currentStep"/>
      }
      @switch (currentStep) {
        @case (1) {
          @if (!approvalsValid) {
            <div class="alert alert-danger">
              @if (employee.employeeType === EmployeeType.PERMANENT) {
                Das Formular kann nicht ausgefüllt werden, da der Genehmigungsweg nicht ermittelt werden konnte. Bitte wenden Sie sich an den Support der HA Mediensysteme und IT <a href="mailto:support@rbb-online.de">support&#64;rbb-online.de</a>.
              } @else {
                @if (pendingEmployeeOrgUnits?.length) {
                  Sie können das Formular erst ausfüllen, wenn <span class="fw-bold">{{pendingEmployeeOrgUnits?.[0]?.approvedByFirstName}} {{pendingEmployeeOrgUnits?.[0]?.approvedByLastName}} die angegebene Organisationseinheit bzw. den auftraggebenden Bereich bestätigt hat</span>. Unter <a routerLink="/my-data">"Meine Daten"</a> können Sie den Verlauf einsehen.
                } @else {
                  Sie können zurzeit das Formular nicht ausfüllen, da für Sie die Personaldaten nicht vollständig ermittelt werden konnten. Sie müssen <span class="fw-bold">Ihre Organisationseinheit bzw. Ihren auftraggebenden Bereich hinterlegen</span>, um rbb Forms nutzen zu können. Dies können Sie unter <a routerLink="/my-data">"Meine Daten"</a> tun.
                }
              }
            </div>
          }
          @if (accessService.usernameContext) {
            <div class="alert alert-secondary">
              Sie füllen das Formular für {{accessService.usernameContextFirstName}} {{accessService.usernameContextLastName}} aus. Sie können das Formular nicht abschicken, sondern nur als Entwurf für die Person abspeichern.
            </div>
          }
          <app-approver-list-user-view [process]="process" [employee]="employee" [form]="form" (orgUnitChanged)="orgUnitChanged()" [loadingEmployee]="approvalsLoading" [approvalsValid]="approvalsValid"/>
          <div class="row position-relative">
            @if (defaultHeader()) {
              <div class="col-12 fw-bold h5 mb-3 mt-3">
                Daten
                <hr class="m-0 p-0">
              </div>
            }
            @if (fillId || (params?.keys?.length && !params?.keys?.includes('fillId'))) {
              <div class="col-12">
                <div class="alert alert-warning">
                  Bitte überprüfen Sie, ob alle Daten korrekt übernommen wurden!
                </div>
              </div>
            }
            @for (field of (process?.fields ?? []); track i; let i = $index) {
              @if (field.formField && field.formField.type && checkConditional(process?.fields ?? [], i)) {
                <div class="col-md-{{field.formField.type === FieldType.HEADER || field.formField.type === FieldType.SEPARATOR_LINE || field.formField.type === FieldType.TABLE || field.formField.type === FieldType.SELECTION_TABLE ? '12' : field.formField.columnWidth}} mb-3" [class.bg-warning]="(form.lastApproved || lastApproved()) && fieldChanged(field.formField)">
                  <div class="pb-3 pt-2 h-100">
                    @if (field.formField.type !== FieldType.HEADER && field.formField.type !== FieldType.SEPARATOR_LINE && field.formField.type !== FieldType.DESCRIPTION && field.formField.type !== FieldType.BLANK_SPACE) {
                      <label class="form-label text-secondary fw-bold" [for]="field.formField.id ?? ''" [innerHTML]="field.formField.required ? processStyleMarkupWithRequired(field.formField.name) : processStyleMarkupWithoutBreaks(field.formField.name)"></label>
                    }
                    @switch (field.formField.type) {
                      @case (FieldType.TEXT) {
                        @if (field.formField.fieldCustomParameter?.rows) {
                          <textarea (input)="checkField(field)" [ngClass]="field.check ? 'is-invalid' : ''" class="form-control auto-grow" [id]="field.formField.id ?? ''" rows="3" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                    [name]="field.formField.id ?? ''"
                                    [maxLength]="field.formField.fieldCustomParameter?.maxLength ? field.formField.fieldCustomParameter?.maxLength : 524288" [minLength]="field.formField.fieldCustomParameter?.minLength"></textarea>
                        } @else {
                          <div class="input-group input-group-sm">
                            <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-align-left" aria-hidden="true"></i></label>
                            <input type="text" (input)="checkField(field)" [ngClass]="field.check ? 'is-invalid' : ''" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                   [name]="field.formField.id ?? ''" autocomplete="off"
                                   [maxLength]="field.formField.fieldCustomParameter?.maxLength ?? 524288" [minLength]="field.formField.fieldCustomParameter?.minLength">
                          </div>
                        }
                      }
                      @case (FieldType.NUMBER) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-calculator" aria-hidden="true"></i></label>
                          <input type="number" [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''"
                                 [(ngModel)]="field.content" [required]="field.formField.required ?? false" autocomplete="off"
                                 [name]="field.formField.id ?? ''" [max]="field.formField.fieldCustomParameter?.max?.toString() ?? Number.MAX_SAFE_INTEGER" [min]="field.formField.fieldCustomParameter?.min?.toString() ?? Number.MIN_SAFE_INTEGER" [step]="field.formField.fieldCustomParameter?.integer ? '1' : '0.1'">
                        </div>
                      }
                      @case (FieldType.DATE) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-calendar" aria-hidden="true"></i></label>
                          <input type="date" (input)="checkField(field)" [ngClass]="field.check ? 'is-invalid' : ''" class="form-control" max="9999-12-31" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false" autocomplete="off" [name]="field.formField.id ?? ''">
                        </div>
                      }
                      @case (FieldType.TIME) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-clock" aria-hidden="true"></i></label>
                          <input type="time" (input)="checkField(field)" [ngClass]="field.check ? 'is-invalid' : ''" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false" autocomplete="off" [name]="field.formField.id ?? ''">
                        </div>
                      }
                      @case (FieldType.PERIOD) {
                        @if (field.formField.fieldCustomParameter) {
                          <div class="row">
                            <div class="col-md-6">
                              <div class="input-group input-group-sm mb-3">
                                <label class="input-group-text same-prepend-width" data-prepend-width-group="period" [for]="(field.formField.id ?? '') + '-from'"><i class="fas fa-calendar" aria-hidden="true"></i>&ensp;Von:</label>
                                <input type="date" (input)="checkField(field)" [ngClass]="field.check ? 'is-invalid' : ''" class="form-control" max="9999-12-31" [id]="(field.formField.id ?? '') + '-from'" [(ngModel)]="field.formField.fieldCustomParameter.fromDate" (ngModelChange)="updatePeriod(field)" [required]="field.formField.required ?? false" autocomplete="off" [name]="(field.formField.id ?? '') + '-from'">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="input-group input-group-sm">
                                <label class="input-group-text same-prepend-width" data-prepend-width-group="period" [for]="(field.formField.id ?? '') + '-to'"><i class="fas fa-calendar" aria-hidden="true"></i>&ensp;Bis:</label>
                                <input [disabled]="field.formField.fieldCustomParameter.toDate === 'unbefristet'" type="date" (input)="checkField(field)" [style.color]="field.formField.fieldCustomParameter.toDate === 'unbefristet' ? 'rgba(0, 0, 0, 0)' : undefined"
                                       [ngClass]="field.formField.fieldCustomParameter.toDate !== 'unbefristet' && field.check ? 'is-invalid' : ''" class="form-control" max="9999-12-31"
                                       [id]="(field.formField.id ?? '') + '-to'" [(ngModel)]="field.formField.fieldCustomParameter.toDate" (ngModelChange)="updatePeriod(field)"
                                       [required]="field.formField.fieldCustomParameter.toDate !== 'unbefristet' && field.formField.required ?? false" autocomplete="off" [name]="(field.formField.id ?? '') + '-to'">
                                @if (field.formField.fieldCustomParameter.unlimited) {
                                  <span class="input-group-text">
                                <div class="form-check mb-0">
                                  <input class="form-check-input" type="checkbox" [name]="(field.formField.id ?? '') + '-unlimited'" [id]="(field.formField.id ?? '') + '-unlimited'" [checked]="field.formField.fieldCustomParameter.toDate === 'unbefristet'" (change)="field.formField.fieldCustomParameter.toDate === 'unbefristet' ? field.formField.fieldCustomParameter.toDate = '' : field.formField.fieldCustomParameter.toDate = 'unbefristet'; updatePeriod(field); checkField(field);">
                                  <label class="form-check-label" [for]="(field.formField.id ?? '') + '-unlimited'">
                                    unbefristet
                                  </label>
                                </div>
                              </span>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      }
                      @case (FieldType.PERCENT) {
                        @if (field.formField.fieldCustomParameter) {
                          <div class="input-group input-group-sm">
                            @if (field.formField.fieldCustomParameter.timeFormat) {
                              <input type="text" (input)="checkField(field)" [ngClass]="field.check ? 'is-invalid' : ''" class="form-control" [id]="(field.formField.id ?? '') + '-absolute'" [(ngModel)]="field.formField.fieldCustomParameter.absolute" (ngModelChange)="updatePercent(field, false, true)" [required]="field.formField.required ?? false" autocomplete="off" [name]="(field.formField.id ?? '') + '-absolute'" placeholder="00:00" pattern="[0-9]+:([0-5][0-9])">
                            } @else {
                              <input type="number" (input)="checkField(field)" [ngClass]="field.check ? 'is-invalid' : ''" class="form-control" [id]="(field.formField.id ?? '') + '-absolute'" [(ngModel)]="field.formField.fieldCustomParameter.absolute" (ngModelChange)="updatePercent(field, false, true)" [required]="field.formField.required ?? false" autocomplete="off" [name]="(field.formField.id ?? '') + '-absolute'" [min]="field.formField.fieldCustomParameter?.lessThanNull ? Number.MIN_SAFE_INTEGER : 0" [max]="field.formField.fieldCustomParameter?.moreThanHundred ? Number.MAX_SAFE_INTEGER : field.formField.fieldCustomParameter.absoluteHundred">
                            }
                            <label class="input-group-text">{{field.formField.fieldCustomParameter.suffix}} entspricht</label>
                            <input type="number" (input)="checkField(field)" [ngClass]="field.check ? 'is-invalid' : ''" class="form-control" [id]="(field.formField.id ?? '') + '-percent'" [(ngModel)]="field.formField.fieldCustomParameter.percent" (ngModelChange)="updatePercent(field, true, false)" [required]="field.formField.required ?? false" autocomplete="off" [name]="(field.formField.id ?? '') + '-percent'" [min]="field.formField.fieldCustomParameter?.lessThanNull ? Number.MIN_SAFE_INTEGER : 0" [max]="field.formField.fieldCustomParameter?.moreThanHundred ? Number.MAX_SAFE_INTEGER : 100">
                            <label class="input-group-text">% von {{field.formField.fieldCustomParameter.absoluteHundred.toString().replace('.', ',')}} {{field.formField.fieldCustomParameter.suffix}}</label>
                          </div>
                        }
                      }
                      @case (FieldType.YES_NO) {
                        @if (!field.formField.required) {
                          <div class="form-check mb-2">
                            <input class="form-check-input" type="radio" name="formFieldYesNo{{i}}" [(ngModel)]="field.content" (change)="checkField(field)" id="formFieldYesNo{{i}}Null" autocomplete="off" [value]="null">
                            <label class="form-check-label" for="formFieldYesNo{{i}}Null">Keine Angabe</label>
                          </div>
                        }
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="radio" name="formFieldYesNo{{i}}" [ngClass]="field.check ? 'is-invalid' : ''" [(ngModel)]="field.content" id="formFieldYesNo{{i}}Yes" (change)="checkField(field)" autocomplete="off" [value]="field.formField.fieldCustomParameter?.yesLabel ?? 'Ja'">
                          <label class="form-check-label" for="formFieldYesNo{{i}}Yes">{{field.formField.fieldCustomParameter?.yesLabel ? field.formField.fieldCustomParameter?.yesLabel : 'Ja'}}</label>
                        </div>
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="radio" name="formFieldYesNo{{i}}" [ngClass]="field.check ? 'is-invalid' : ''" [(ngModel)]="field.content" id="formFieldYesNo{{i}}No" (change)="checkField(field)" autocomplete="off" [value]="field.formField.fieldCustomParameter?.noLabel ?? 'Nein'">
                          <label class="form-check-label" for="formFieldYesNo{{i}}No">{{field.formField.fieldCustomParameter?.noLabel ? field.formField.fieldCustomParameter?.noLabel : 'Nein'}}</label>
                        </div>
                      }
                      @case (FieldType.SELECTION) {
                        @if (field.formField.fieldCustomParameter?.maxSelection === 1) {
                          @if (!field.formField.fieldCustomParameter?.other && (field.formField.fieldCustomParameter?.items?.length ?? 0) > 10) {
                            <select class="form-select form-select-sm" [ngClass]="field.check ? 'is-invalid' : ''" [(ngModel)]="contentSelect[field.id ?? '']" (ngModelChange)="changeRadioSelection(field, $event.toString())">
                              @if (!field.formField.required) {<option [value]="null">Keine Angaben</option>}
                              @for (option of getItems(field); track option) {
                                <option [value]="option">{{option}}</option>
                              }
                            </select>
                          } @else {
                            @if (!field.formField.required) {
                              <div class="form-check mb-2">
                                <input class="form-check-input" type="radio" id="formFieldSelectionRadio{{i}}Null" name="formFieldSelectionRadio{{i}}" (change)="changeRadioSelection(field, null); checkField(field)" [checked]="field.content.length === 0" autocomplete="off">
                                <label class="form-check-label" for="formFieldSelectionRadio{{i}}Null">Keine Angabe</label>
                              </div>
                            }
                            @for (option of getItems(field); track option; let j = $index) {
                              <div class="form-check">
                                <input class="form-check-input" type="radio" id="formFieldSelectionRadio{{i}}-{{j}}" name="formFieldSelectionRadio{{i}}" [ngClass]="field.check ? 'is-invalid' : ''" (change)="changeRadioSelection(field, option); checkField(field)" autocomplete="off" [checked]="field.content.includes(option)">
                                <label class="form-check-label" for="formFieldSelectionRadio{{i}}-{{j}}">{{option}}</label>
                              </div>
                            }
                            @if (field.formField.fieldCustomParameter?.other) {
                              <div class="form-check">
                                <input class="form-check-input" type="radio" id="formFieldSelectionRadio{{i}}Other" name="formFieldSelectionRadio{{i}}" [ngClass]="field.check ? 'is-invalid' : ''" (change)="changeRadioSelection(field, 'Sonstiges: ' + otherInputs[field.id ?? '']); checkField(field)" autocomplete="off" [checked]="field.content.includes('Sonstiges: ' + otherInputs[field.id ?? ''])">
                                <label class="form-check-label" for="formFieldSelectionRadio{{i}}Other">Sonstiges</label>
                                @if (field.content.includes('Sonstiges: ' + otherInputs[field.id ?? ''])) {
                                  <input type="text" class="form-control form-control-sm no-clear-button" id="formFieldSelectionRadio{{i}}OtherInput" name="formFieldSelectionRadio{{i}}OtherInput" autocomplete="off" [(ngModel)]="otherInputs[field.id ?? '']" (ngModelChange)="updateOtherSelection(field)">
                                }
                              </div>
                            }
                          }
                        } @else {
                          @for (option of getItems(field); track option; let j = $index) {
                            <div class="form-check">
                              <input class="form-check-input"
                                     [ngClass]="field.check ? 'is-invalid' : ''"
                                     type="checkbox"
                                     autocomplete="off"
                                     id="formFieldSelectionCheckbox{{i}}-{{j}}"
                                     name="formFieldSelectionCheckbox{{i}}-{{j}}"
                                     [checked]="field.content.includes(option)"
                                     (change)="checkboxController(field, option, $event); checkField(field)">
                              <label class="form-check-label" for="formFieldSelectionCheckbox{{i}}-{{j}}">{{option}}</label>
                            </div>
                          }
                          @if (field.formField.fieldCustomParameter?.other) {
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="formFieldSelectionCheckbox{{i}}Other" name="formFieldSelectionCheckbox{{i}}Other" [ngClass]="field.check ? 'is-invalid' : ''" (change)="checkboxController(field, 'Sonstiges: ' + otherInputs[field.id ?? ''], $event); checkField(field)" autocomplete="off" [(ngModel)]="otherChecked[field.id ?? '']" [value]="['Sonstiges: ' + otherInputs[field.id ?? '']]">
                              <label class="form-check-label" for="formFieldSelectionCheckbox{{i}}Other">Sonstiges</label>
                              @if (field.formField.fieldCustomParameter?.otherChecked) {
                                <input type="text" class="form-control form-control-sm no-clear-button" id="formFieldSelectionCheckbox{{i}}OtherInput" name="formFieldSelectionCheckbox{{i}}OtherInput" min="1" [(ngModel)]="otherInputs[field.id ?? '']" autocomplete="off" (ngModelChange)="updateOtherSelection(field)">
                              }
                            </div>
                          }
                        }
                      }
                      @case (FieldType.SELECTION_PLUS) {
                        @if (field.formField.fieldCustomParameter?.maxSelection === 1) {
                          @if (!field.formField.required) {
                            <div class="form-check mb-2">
                              <input class="form-check-input" type="radio" id="formFieldSelectionPlusRadio{{i}}Null" name="formFieldSelectionPlusRadio{{i}}" (change)="changeRadioSelectionPlus(field, null); checkField(field)" [checked]="field.content.length === 0" autocomplete="off">
                              <label class="form-check-label" for="formFieldSelectionPlusRadio{{i}}Null">Keine Angabe</label>
                            </div>
                          }
                          @for (option of getItems(field); track option; let j = $index) {
                            <div class="form-check">
                              @if (!field.formField.fieldCustomParameter?.sum || option !== 'Summe') {
                                <input class="form-check-input" type="radio" id="formFieldSelectionPlusRadio{{i}}-{{j}}" name="formFieldSelectionPlusRadio{{i}}" [ngClass]="field.check ? 'is-invalid' : ''" (change)="changeRadioSelectionPlus(field, option); checkField(field)" [checked]="field.content.includes(option + ' -> ' + field.formField.fieldCustomParameter?.additional[option] + (field.formField.fieldCustomParameter?.suffix ?? ''))" autocomplete="off">
                                <label class="form-check-label" for="formFieldSelectionPlusRadio{{i}}-{{j}}">{{option}}</label>
                                @if (field.content.includes(option + ' -> ' + field.formField.fieldCustomParameter?.additional[option] + (field.formField.fieldCustomParameter?.suffix ?? ''))) {
                                  <div class="input-group input-group-sm">
                                    <input type="text" class="form-control no-clear-button" id="formFieldSelectionPlusRadio{{i}}Additional" name="formFieldSelectionPlusRadio{{i}}Additional" [(ngModel)]="field.formField.fieldCustomParameter?.additional[option]" (ngModelChange)="updateSelectionPlus(field, option); checkField(field)" autocomplete="off">
                                    @if (field.formField.fieldCustomParameter?.suffix) {
                                      <span class="input-group-text">{{field.formField.fieldCustomParameter?.suffix}}</span>
                                    }
                                  </div>
                                }
                              } @else {
                                <div class="fw-bold">Summe -> {{sumSelectionPlus(field)}}</div>
                              }
                            </div>
                          }
                        } @else {
                          @for (option of getItems(field); track option; let j = $index) {
                            <div class="form-check">
                              @if (!field.formField.fieldCustomParameter?.sum || option !== 'Summe') {
                                <input class="form-check-input"
                                       [ngClass]="field.check ? 'is-invalid' : ''"
                                       type="checkbox"
                                       autocomplete="off"
                                       id="formFieldSelectionPlusCheckbox{{i}}-{{j}}"
                                       name="formFieldSelectionPlusCheckbox{{i}}-{{j}}"
                                       [checked]="field.content.includes(option + ' -> ' + field.formField.fieldCustomParameter?.additional[option] + (field.formField.fieldCustomParameter?.suffix ?? ''))"
                                       (change)="checkboxControllerPlus(field, option, $event); checkField(field)">
                                <label class="form-check-label" for="formFieldSelectionPlusCheckbox{{i}}-{{j}}">{{option}}</label>
                                @if (field.content.includes(option + ' -> ' + field.formField.fieldCustomParameter?.additional[option] + (field.formField.fieldCustomParameter?.suffix ?? ''))) {
                                  <div class="input-group input-group-sm">
                                    <input type="text" class="form-control no-clear-button" id="formFieldSelectionPlusCheckbox{{i}}Additional" name="formFieldSelectionPlusCheckbox{{i}}Additional" [(ngModel)]="field.formField.fieldCustomParameter?.additional[option]" (ngModelChange)="updateSelectionPlus(field, option); checkField(field)" autocomplete="off">
                                    @if (field.formField.fieldCustomParameter?.suffix) {
                                      <span class="input-group-text">{{field.formField.fieldCustomParameter?.suffix}}</span>
                                    }
                                  </div>
                                }
                              } @else {
                                <div class="fw-bold">Summe -> {{sumSelectionPlus(field)}}</div>
                              }
                            </div>
                          }
                        }
                      }
                      @case (FieldType.LIST) {
                        <div class="form-group mb-2">
                          <div class="row">
                            @for (h of field.content; let j = $index; track j) {
                              <div class="col-12">
                                <input [ngClass]="field.check ? 'is-invalid' : ''" type="text" id="formFieldList{{i}}-{{j}}" name="formFieldList{{i}}-{{j}}" class="form-control form-control-sm" [(ngModel)]="field.content[j]" (input)="checkField(field)" placeholder="Eintrag {{j + 1}}" [attr.aria-label]="'Eintrag ' + (j + 1)" autocomplete="off">
                              </div>
                            }
                          </div>
                        </div>
                        @if (field.formField.fieldCustomParameter?.min !== field.formField.fieldCustomParameter?.max || !field.formField.fieldCustomParameter?.min) {
                          <div class="row">
                            <div class="col">
                              <hr class="m-0 p-0 hr-custom">
                            </div>
                            <div class="col-auto">
                              <button type="button" class="btn btn-sm btn-outline-success me-2" (click)="addCustomFieldListItem(field); checkField(field);" aria-label="Eintrag hinzufügen"><i class="fas fa-plus" aria-hidden="true"></i></button>
                              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeCustomFieldListItem(field); checkField(field);" aria-label="Eintrag entfernen"><i class="fas fa-minus" aria-hidden="true"></i></button>
                            </div>
                            <div class="col">
                              <hr class="m-0 p-0 hr-custom">
                            </div>
                          </div>
                        }
                      }
                      @case (FieldType.PERIODS) {
                        <div class="form-group mb-2">
                          <div class="row">
                            @for (h of field.content; let j = $index; track j) {
                              <div class="col-12">
                                <div class="input-group input-group-sm">
                                  <label class="input-group-text">Von</label>
                                  <input [ngClass]="field.check ? 'is-invalid' : ''" type="date" id="formFieldPeriods{{i}}-{{j}}From" name="formFieldPeriods{{i}}-{{j}}From" class="form-control form-control-sm" [(ngModel)]="field.formField.fieldCustomParameter.fromDate[j]" (input)="updatePeriodsContent(field, j); checkField(field)" [attr.aria-label]="(j + 1) + '. Startdatum'" autocomplete="off">
                                  <label class="input-group-text">bis</label>
                                  <input [ngClass]="field.check ? 'is-invalid' : ''" type="date" id="formFieldPeriods{{i}}-{{j}}To" name="formFieldPeriods{{i}}-{{j}}To" class="form-control form-control-sm" [(ngModel)]="field.formField.fieldCustomParameter.toDate[j]" (input)="updatePeriodsContent(field, j); checkField(field)" [attr.aria-label]="(j + 1) + '. Enddatum'" autocomplete="off">
                                  <label class="input-group-text">-> {{calculateDays(field, j)}} Tage</label>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        @if (field.formField.fieldCustomParameter?.min !== field.formField.fieldCustomParameter?.max || !field.formField.fieldCustomParameter?.min) {
                          <div class="row">
                            <div class="col">
                              <hr class="m-0 p-0 hr-custom">
                            </div>
                            <div class="col-auto">
                              <button type="button" class="btn btn-sm btn-outline-success me-2" (click)="addCustomFieldPeriod(field); checkField(field);" aria-label="Eintrag hinzufügen"><i class="fas fa-plus" aria-hidden="true"></i></button>
                              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeCustomFieldPeriod(field); checkField(field);" aria-label="Eintrag entfernen"><i class="fas fa-minus" aria-hidden="true"></i></button>
                            </div>
                            <div class="col">
                              <hr class="m-0 p-0 hr-custom">
                            </div>
                          </div>
                        }
                      }
                      @case (FieldType.TABLE) {
                        <div class="form-group mb-2">
                          <div class="row">
                            <div class="col-12">
                              <table class="table table-sm">
                                <thead>
                                <tr>
                                  @for (header of getHead(field); track header) {
                                    <th>{{header}}</th>
                                  }
                                </tr>
                                </thead>
                                <tbody>
                                @for (row of field.content; let j = $index; track j) {
                                  <tr>
                                    @if (j > 0 && (!field.formField.fieldCustomParameter?.sum || j < field.content.length - 1)) {
                                      @for (ignored of row; let k = $index; track k) {
                                        <td>
                                          <input [ngClass]="field.check ? 'is-invalid' : ''" type="text" id="formField{{i}}Row{{j}}Cell{{k}}" name="formField{{i}}Row{{j}}Cell{{k}}" class="form-control form-control-sm" [(ngModel)]="field.content[j][k]" (input)="checkField(field)" [attr.aria-label]="'Reihe ' + j + ', Spalte ' + (k + 1)" autocomplete="off">
                                        </td>
                                      }
                                    }
                                  </tr>
                                }
                                @if (field.formField.fieldCustomParameter?.sum) {
                                  <tr class="sum-row fw-bold">
                                    @for (header of getHead(field); track header; let j = $index) {
                                      <td>{{sumTableColumn(field, j)}}</td>
                                    }
                                  </tr>
                                }
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        @if (field.formField.fieldCustomParameter?.min !== field.formField.fieldCustomParameter?.max || !field.formField.fieldCustomParameter?.min) {
                          <div class="row">
                            <div class="col">
                              <hr class="m-0 p-0 hr-custom">
                            </div>
                            <div class="col-auto">
                              <button type="button" class="btn btn-sm btn-outline-success me-2"  (click)="addCustomFieldTableRow(field); checkField(field);" aria-label="Reihe hinzufügen"><i class="fas fa-plus" aria-hidden="true"></i></button>
                              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeCustomFieldTableRow(field); checkField(field);" aria-label="Reihe entfernen"><i class="fas fa-minus" aria-hidden="true"></i></button>
                            </div>
                            <div class="col">
                              <hr class="m-0 p-0 hr-custom">
                            </div>
                          </div>
                        }
                      }
                      @case (FieldType.SELECTION_TABLE) {
                        <div class="form-group mb-2">
                          <div class="row">
                            <div class="col-12">
                              <table class="table table-sm">
                                <thead>
                                <tr>
                                  <th></th>
                                  @for (option of getOptions(field); track option) {
                                    <th class="text-center" [innerHtml]="processStyleMarkup(option)"></th>
                                  }
                                </tr>
                                </thead>
                                <tbody>
                                  @for (item of getItems(field); let j = $index; track item) {
                                    <tr>
                                      <td [innerHtml]="processStyleMarkup(item)"></td>
                                      @for (option of getOptions(field); let k = $index; track k) {
                                        <td class="text-center">
                                          @if (field.formField.required && !field.formField.fieldCustomParameter.multipleOptionsPerItem) {
                                            <input [ngClass]="field.check ? 'is-invalid' : ''" type="radio" id="formField{{i}}Item{{j}}Option{{k}}" name="formField{{i}}Item{{j}}Options" class="form-check-input" [attr.aria-label]="option"
                                                   [checked]="field.content[item]?.includes(option)" (change)="field.content[item] = [option]; checkField(field);">
                                            <label class="form-check-label" for="formField{{i}}Item{{j}}Option{{k}}"></label>
                                          } @else {
                                            <input [ngClass]="field.check ? 'is-invalid' : ''" type="checkbox" id="formField{{i}}Item{{j}}Option{{k}}" name="formField{{i}}Item{{j}}Option{{k}}" class="form-check-input" [attr.aria-label]="option"
                                                   [checked]="field.content[item]?.includes(option)" (change)="changeSelectionTable(field, item, option); checkField(field);">
                                            <label class="form-check-label" for="formField{{i}}Item{{j}}Option{{k}}"></label>
                                          }
                                        </td>
                                      }
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      }
                      @case (FieldType.ROOM) {
                        @if (!field.formField.fieldCustomParameter?.forceSelection) {
                          <div class="input-group input-group-sm">
                            <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="far fa-building" aria-hidden="true"></i></label>
                            <input type="text" [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                   [disabled]="field.formField.fieldCustomParameter?.forceSelection" autocomplete="off"
                                   [name]="field.formField.id ?? ''" [attr.list]="'formFieldRoom' + i + 'Rooms'">
                            <datalist id="formFieldRoom{{i}}Rooms">
                              @for (room of rooms; track room) {
                                <option [value]="room.value">{{room.value}}</option>
                              }
                            </datalist>
                          </div>
                        } @else {
                          <rbb-multi-select [ngClass]="field.check ? 'is-invalid' : ''"
                                            prependIcon="far fa-building"
                                            [itemTemplate]="roomSearch"
                                            [values]="rooms"
                                            [max]="1"
                                            size="md"
                                            [searchFields]="['value']"
                                            [id]="field.formField.id ?? ''"
                                            [(ngModel)]="field.formField.fieldCustomParameter.select"
                                            (ngModelChange)="updateRooms(field); checkField(field);"
                                            [name]="field.formField.id ?? ''"/>
                          <ng-template let-value="value" #roomSearch>
                            {{value.value}}
                          </ng-template>
                        }
                      }
                      @case (FieldType.ORG_UNIT) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-sitemap" aria-hidden="true"></i></label>
                          <input type="text" readonly disabled [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                 [name]="field.formField.id ?? ''" autocomplete="off">
                        </div>
                      }
                      @case (FieldType.COST_CENTRE) {
                        @if (!field.formField.fieldCustomParameter?.forceSelection) {
                          <div class="input-group input-group-sm">
                            <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-money-check-alt" aria-hidden="true"></i></label>
                            <input type="text" [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                   [name]="field.formField.id ?? ''" [attr.list]="'formFieldCostCentreList' + i" autocomplete="off">
                            <datalist id="formFieldCostCentreList{{i}}">
                              @for (option of costCentres; track option.costCentre) {
                                <option [value]="option.costCentre">{{option.costCentre}} ({{option.description}})</option>
                              }
                            </datalist>
                          </div>
                        } @else {
                          <rbb-multi-select [ngClass]="field.check ? 'is-invalid' : ''"
                                            [itemTemplate]="costCentreSearch" prependIcon="fas fa-money-check-alt"
                                            [values]="costCentres"
                                            [max]="1"
                                            size="md"
                                            [id]="field.formField.id ?? ''"
                                            [searchFields]="['costCentre', 'description']"
                                            [(ngModel)]="field.formField.fieldCustomParameter.select"
                                            (ngModelChange)="updateCostCentre(field); checkField(field); reloadApprovers(field);"
                                            [name]="field.formField.id ?? ''"/>
                          <ng-template let-value="value" #costCentreSearch>
                            {{value.costCentre}} ({{value.description}})
                          </ng-template>
                        }
                      }
                      @case (FieldType.EMPLOYEE_TYPE) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-file-contract" aria-hidden="true"></i></label>
                          <input type="text" readonly disabled [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [required]="field.formField.required ?? false" [name]="field.formField.id ?? ''" [value]="mapEmployeeType(field.content)" autocomplete="off">
                        </div>
                      }
                      @case (FieldType.EMPLOYEE_NUMBER) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-id-card" aria-hidden="true"></i></label>
                          <input type="text" readonly disabled [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                 [name]="field.formField.id ?? ''" autocomplete="off">
                        </div>
                      }
                      @case (FieldType.MOBILE_WORK_AGREEMENT) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-id-card" aria-hidden="true"></i></label>
                          <input type="text" readonly disabled [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                 [name]="field.formField.id ?? ''" autocomplete="off">
                        </div>
                      }
                      @case (FieldType.DISABILITY_STATUS) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-id-card" aria-hidden="true"></i></label>
                          <input type="text" readonly disabled [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                 [name]="field.formField.id ?? ''" autocomplete="off">
                        </div>
                      }
                      @case (FieldType.CLIENT) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-laptop" aria-hidden="true"></i></label>
                          <input [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                 [name]="field.formField.id ?? ''" [attr.list]="'clientList'" autocomplete="off">
                          <datalist id="clientList">
                            @for (option of clientList; track option) {
                              <option [value]="option">
                            }
                          </datalist>
                        </div>
                      }
                      @case (FieldType.TELEPHONE) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-phone" aria-hidden="true"></i></label>
                          <input type="text" [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                 [name]="field.formField.id ?? ''" autocomplete="off">
                        </div>
                      }
                      @case (FieldType.MOBILE) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id"><i class="fas fa-mobile-alt" aria-hidden="true"></i></label>
                          <input type="text" [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                 [name]="field.formField.id ?? ''" autocomplete="off">
                        </div>
                      }
                      @case (FieldType.FAX) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="fas fa-fax" aria-hidden="true"></i></label>
                          <input type="text" [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                 [name]="field.formField.id ?? ''" autocomplete="off">
                        </div>
                      }
                      @case (FieldType.EMAIL) {
                        <div class="input-group input-group-sm">
                          <label class="input-group-text" [for]="field.formField.id ?? ''"><i class="far fa-envelope" aria-hidden="true"></i></label>
                          <input type="text" [ngClass]="field.check ? 'is-invalid' : ''" (input)="checkField(field)" class="form-control" [id]="field.formField.id ?? ''" [(ngModel)]="field.content" [required]="field.formField.required ?? false"
                                 [name]="field.formField.id ?? ''" autocomplete="off">
                        </div>
                      }
                      @case (FieldType.ACCOUNT) {
                        <rbb-multi-select
                          [ngClass]="field.check ? 'is-invalid' : ''"
                          [itemTemplate]="accountSearch" prependIcon="fa-solid fa-user"
                          [loadValuesFunctionOptions]="field.formField.id"
                          [loadValuesFunction]="searchAccount"
                          [max]="field.formField.fieldCustomParameter.max ?? (field.formField.fieldCustomParameter.min ? undefined : 1)"
                          size="md"
                          [id]="field.formField.id ?? ''"
                          [(ngModel)]="field.formField.fieldCustomParameter.select"
                          (ngModelChange)="updateAccount(field); checkField(field);"
                          [name]="field.formField.id ?? ''"/>
                        <ng-template let-value="value" #accountSearch>
                          {{value}}
                        </ng-template>
                      }
                      @case (FieldType.PERSON) {
                        <rbb-multi-select
                          [ngClass]="field.check ? 'is-invalid' : ''"
                          [itemTemplate]="personSearch" prependIcon="fa-solid fa-user"
                          [loadValuesFunctionOptions]="field.formField.id"
                          [loadValuesFunction]="searchPerson"
                          [max]="1"
                          size="md"
                          [id]="field.formField.id ?? ''"
                          [(ngModel)]="field.formField.fieldCustomParameter.select"
                          (ngModelChange)="updatePerson(field); checkField(field); reloadApprovers(field);"
                          [name]="field.formField.id ?? ''"/>
                        <ng-template let-value="value" #personSearch>
                          {{value.firstName | titlecase}} {{value.lastName | titlecase}} ({{value.username}})
                        </ng-template>
                      }
                      @case (FieldType.PERSON_LIST) {
                        <rbb-multi-select
                          [ngClass]="field.check ? 'is-invalid' : ''"
                          [itemTemplate]="personListSearch" prependIcon="fa-solid fa-user"
                          [loadValuesFunctionOptions]="field.formField.id"
                          [loadValuesFunction]="searchPerson"
                          [max]="field.formField.fieldCustomParameter.max ?? 0"
                          size="md"
                          [id]="field.formField.id ?? ''"
                          [(ngModel)]="field.formField.fieldCustomParameter.select"
                          (ngModelChange)="updatePersonList(field); checkField(field);"
                          [name]="field.formField.id ?? ''"/>
                        <ng-template let-value="value" #personListSearch>
                          {{value.firstName | titlecase}} {{value.lastName | titlecase}} ({{value.username}})
                        </ng-template>
                      }
                      @case (FieldType.PRODUCTION_UNIT) {
                        <rbb-multi-select
                          [ngClass]="field.check ? 'is-invalid' : ''"
                          [itemTemplate]="productionUnitSearch" prependIcon="fa-solid fa-server"
                          [values]="productionUnits"
                          [searchFields]="['Bezeichnung']"
                          [max]="field.formField.fieldCustomParameter.max ?? 0"
                          size="md"
                          [id]="field.formField.id ?? ''"
                          [(ngModel)]="field.formField.fieldCustomParameter.select"
                          (ngModelChange)="updateProductionUnit(field); checkField(field);"
                          [name]="field.formField.id ?? ''"/>
                        <ng-template let-value="value" #productionUnitSearch>
                          {{value.Bezeichnung}}
                        </ng-template>
                      }
                      @case (FieldType.FILE) {
                        <div class="form-group mb-2">
                          <div class="row">
                            <div class="col-12">
                              <ul>
                                @for (h of field.content; track h; let j = $index) {
                                  <li>{{h.name}}&ensp;<i class="fas fa-times text-danger d-inline-block grow-effect transform pointer" aria-hidden="true" aria-label="Datei entfernen" (click)="removeFile(field, j)"></i></li>
                                }
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                          <div class="col-auto">
                            <button type="button" class="btn btn-sm btn-outline-success me-2" (click)="openFileModal(field)" aria-label="Datei hochladen">Datei hochladen</button>
                          </div>
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                        </div>
                      }
                      @case (FieldType.HEADER) {
                        <div class="fw-bold h5 mt-3" [innerHTML]="processStyleMarkupWithoutBreaks(field.formField.name)"></div>
                        <hr class="m-0 p-0">
                      }
                      @case (FieldType.SEPARATOR_LINE) {
                        <hr class="m-0 p-0">
                      }
                      @case (FieldType.DESCRIPTION) {
                        <div [innerHTML]="processStyleMarkup(field.formField.fieldCustomParameter.value)"></div>
                      }
                    }
                    @if (field.formField.type === FieldType.APPLICATION || field.formField.type === FieldType.BIMEDIAL || field.formField.type === FieldType.CAD || field.formField.type === FieldType.CONFLUENCE || field.formField.type === FieldType.FILESERVICE || field.formField.type === FieldType.GENERAL || field.formField.type === FieldType.IT || field.formField.type === FieldType.JIRA || field.formField.type === FieldType.MCLOUD || field.formField.type === FieldType.MUSIC_MASTER || field.formField.type === FieldType.PROJECT || field.formField.type === FieldType.RABBIT) {
                      @if (field.formField.type === FieldType.APPLICATION) {
                        <p>Bitte tragen Sie für <span class="fw-bold">jede ausgewählte Option</span> ein, welche Rechte <span class="fw-bold">benötigt, befristet oder entfernt</span> werden soll.</p>
                      }
                      @for (option of getVisibleGroupOptions(field, field.formField.type === FieldType.APPLICATION); track option; let j = $index) {
                        <div class="form-check">
                          <input class="form-check-input"
                                 [ngClass]="field.check ? 'is-invalid' : ''"
                                 type="checkbox"
                                 autocomplete="off"
                                 id="formFieldGroupCheckbox{{i}}-{{j}}"
                                 name="formFieldGroupCheckbox{{i}}-{{j}}"
                                 [checked]="field.content.includes(option + ' -> ' + field.formField.fieldCustomParameter?.additional[option])"
                                 (change)="checkboxControllerPlus(field, option, $event); checkField(field)">
                          <label class="form-check-label" for="formFieldGroupCheckbox{{i}}-{{j}}">{{option}}</label>
                          @if (field.content.includes(option + ' -> ' + field.formField.fieldCustomParameter?.additional[option])) {
                            <input type="text" class="form-control form-control-sm no-clear-button" id="formFieldGroupCheckbox{{i}}Additional" name="formFieldGroupCheckbox{{i}}Additional" [(ngModel)]="field.formField.fieldCustomParameter?.additional[option]" (ngModelChange)="updateSelectionPlus(field, option); checkField(field)" autocomplete="off" [placeholder]="groupFieldPlaceholder(field)" [title]="groupFieldPlaceholder(field)" [attr.aria-label]="groupFieldPlaceholder(field)" [attr.list]="groupSuggestions?.[field.formField.type] ? field.formField.type + '-list' : undefined">
                          }
                        </div>
                      }
                      @if (groupSuggestions?.[field.formField.type]) {
                        <datalist [id]="field.formField.type + '-list'">
                          @for (s of groupSuggestions?.[field.formField.type]; track s) {
                            <option [value]="s">
                              }
                        </datalist>
                      }
                      @if (field.formField.type !== FieldType.APPLICATION) {
                        <div>
                          <button class="btn btn-sm btn-secondary my-3" (click)="openGroupModal(field)">
                            Auswahl öffnen
                          </button>
                        </div>
                      }
                    }
                    @if (field.check) {
                      <div class="small text-danger">
                        {{field.check}}
                      </div>
                    }
                    @if (field.formField.description) {
                      <div class="small text-secondary ps-1 pt-2">
                        <i class="fas fa-info pe-1"></i><span [innerHTML]="processStyleMarkupWithoutBreaks(field.formField.description)"></span>
                      </div>
                    }
                  </div>
                </div>
              }
            }
            <div class="col-12">
              Felder mit <sup class="text-primary">*</sup> müssen ausgefüllt werden.
            </div>
            @if (getFieldErrors()) {
              <div class="col-12 mt-2 text-danger text-center">Im Formular gibt es noch {{getFieldErrors()}} Fehler.</div>
            }
            @if (!approvalsValid) {
              <div class="h-100 w-100" style="position: absolute; background-color: #0006; top: 0; left: 0; z-index: 1000;"></div>
            }
          </div>
        }
        @case (2) {
          <app-privacy-policy [form]="form"/>
        }
        @case (3) {
          <app-approver-list-user-view [process]="process" [employee]="employee" [form]="form" (orgUnitChanged)="orgUnitChanged()" [loadingEmployee]="approvalsLoading"/>
          <app-process-preview [process]="prepareFinalProcess(process)"/>
        }
      }
      @if (!isPreview) {
        <div class="text-center">
          <hr>
          <button routerLink="/list" class="btn mt-2 btn-danger"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Abbrechen</button>
          @if (approvalsValid) {
            @if (process?.status === ProcessStatus.DRAFT) {
              <button (click)="saveFormAsDraft(false)" class="btn ms-2 mt-2 btn-secondary"><i class="fas fa-save" aria-hidden="true"></i>&ensp;Als Entwurf speichern</button>
              @if (accessService.usernameContext) {
                <button (click)="saveFormAsDraft(true)" class="btn ms-2 mt-2 btn-secondary"><i class="fas fa-save" aria-hidden="true"></i>&ensp;Als Entwurf speichern und Antragssteller benachrichtigen</button>
              }
            }
            <button (click)="createDraftUrl()" class="btn ms-2 mt-2 btn-secondary" data-toggle="tooltip" data-placement="top" aria-hidden="true" title="Dieses Feature bietet Ihnen die Möglichkeit einige Felder für andere bereits zu füllen."><i class="fa-solid fa-link"></i>&ensp;Entwurf-URL generieren</button>
          }
          @if (!accessService.usernameContext) {
            @if (currentStep !== 1) {
              <button (click)="changeCurrentStep(currentStep - 1)" class="btn ms-2 mt-2 btn-secondary"><i class="fas fa-arrow-left" aria-hidden="true"></i>&ensp;Zurück</button>
            }
            @if (approvalsValid) {
              @switch (currentStep) {
                @case(1) {
                  @if (checkPrivacy) {
                    <button (click)="checkFieldAndForward()" class="btn ms-2 mt-2 btn-success"><i class="fas fa-arrow-right" aria-hidden="true"></i>&ensp;Datenschutzerklärung anzeigen</button>
                    <button (click)="checkFieldAndForward(); checkFieldAndForward()" class="btn ms-2 mt-2 btn-success"><i class="fas fa-arrow-right" aria-hidden="true"></i>&ensp;Weiter zum Abschicken</button>
                  } @else {
                    <button (click)="checkFieldAndForward()" class="btn ms-2 mt-2 btn-success"><i class="fas fa-arrow-right" aria-hidden="true"></i>&ensp;Weiter</button>
                  }
                }
                @case(2) {
                  <button (click)="checkPrivacy = true; checkFieldAndForward();" class="btn ms-2 mt-2 btn-success"><i class="fas fa-arrow-right" aria-hidden="true"></i>&ensp;Ich habe die Datenschutzerklärung zur Kenntnis genommen</button>
                }
                @case(3) {
                  @if (process?.status === ProcessStatus.DRAFT) {
                    <button (click)="checkFormAndSend()" [disabled]="(!checkAll || !checkPrivacy)" class="btn ms-2 mt-2 btn-success"><i class="fas fa-paper-plane" aria-hidden="true"></i>&ensp;Antrag senden</button>
                  }
                }
              }
            }
          }
        </div>
      }
      @if (draftUrl) {
        <div class="alert alert-secondary mt-3">
          <h6 class="strong">Nutzen Sie diese Adresse, um die oben aufgefüllten Felder beim nächsten mal bereits zu füllen.</h6>
          <p>Diese Funktion unterstützt keine Dateien!</p>
          <small class="text-secondary">
            <i class="fas fa-copy text-secondary pointer" [rbbCopyTooltip]="draftUrl"></i>
            {{draftUrl}}
          </small>
        </div>
      }
    </div>
  </div>
}

@if (form && employee) {
  @if ((!(form.visible || isPreview) && !employee.tester)) {
    <div class="container">
      <div class="alert alert-danger">
        Das Formular existiert nicht mehr oder wurde von der Fachabteilung vorübergehend offline genommen.
      </div>
    </div>
  }
} @else {
  <div class="text-center m-auto mt-5">
    <rbb-loader/>
    <small class="text-secondary d-block">Formular wird geladen...</small>
  </div>
}


<ng-template #ngFileModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">Vorschau</h5>
  </div>
  <div class="modal-body p-3">
    <div class="text-center text-secondary small mt-1 mb-3 ">Es dürfen nur folgende Dateien hochgeladen werden: {{getAllowedFileTypes(fileField).join(', ')}}</div>
    <div class="input-group input-group-sm mb-3">
      <input type="file" class="form-control" id="customFile" [accept]="getAllowedFileTypes(fileField).join(',')" [disabled]="fileContent" (change)="fileSelected($event)" autocomplete="off">
    </div>
    @if (checking) {
      <div class="text-center m-auto mt-5">
        <rbb-loader/>
        <small class="text-secondary d-block">Datei wird überprüft...</small>
      </div>
    }
    @if (checkingError) {
      <div class="text-center text-danger">
        {{checkingError}}
      </div>
    }
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="closeFileModal()" class="btn btn-secondary btn-sm" type="button"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen</button>
  </div>
</ng-template>

<ng-template #groupModal let-modal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">{{selectedGroupField?.formField?.name}}</h5>
    <button class="btn-close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body p-3">
    @if (selectedGroupField && selectedGroupField.formField && selectedGroupField.formField.type) {
      <div class="mb-2">Bitte tragen Sie für <span class="fw-bold">jede ausgewählte Option</span> ein, welche Rechte <span class="fw-bold">benötigt, befristet oder entfernt</span> werden soll.</div>
      <div class="mb-2">
        <div class="input-group input-group-sm">
          <label class="input-group-text" [for]="groupSearch">Suche</label>
          <input class="form-control form-control-sm" type="text" [id]="groupSearch" [(ngModel)]="groupSearch" [name]="groupSearch" autocomplete="off">
        </div>
      </div>
      @for (option of getVisibleGroupOptions(selectedGroupField, true); track option; let j = $index) {
        <div class="form-check" [class.d-none]="!selectedGroupField.content.includes(option + ' -> ' + selectedGroupField.formField.fieldCustomParameter?.additional[option]) && groupSearch && !option.toLowerCase().includes(groupSearch.toLowerCase())">
          <input class="form-check-input"
                 [ngClass]="selectedGroupField.check ? 'is-invalid' : ''"
                 type="checkbox"
                 autocomplete="off"
                 id="formFieldGroupCheckboxSelected{{j}}"
                 name="formFieldGroupCheckboxSelected{{j}}"
                 [checked]="selectedGroupField.content.includes(option + ' -> ' + selectedGroupField.formField.fieldCustomParameter?.additional[option])"
                 (change)="checkboxControllerPlus(selectedGroupField, option, $event); checkField(selectedGroupField)">
          <label class="form-check-label" for="formFieldGroupCheckboxSelected{{j}}">
            @for (s of groupFormatSplit(option); track s; let i = $index) {
              <span [class.bg-warning]="i % 2 === 1">{{s}}</span>
            }
          </label>
          @if (selectedGroupField.content.includes(option + ' -> ' + selectedGroupField.formField.fieldCustomParameter?.additional[option])) {
            <input type="text" class="form-control form-control-sm no-clear-button" id="formFieldGroupCheckboxSelected{{j}}Additional" name="formFieldGroupCheckboxSelected{{j}}Additional" [(ngModel)]="selectedGroupField.formField.fieldCustomParameter?.additional[option]" (ngModelChange)="updateSelectionPlus(selectedGroupField, option); checkField(selectedGroupField)" autocomplete="off" [placeholder]="groupFieldPlaceholder(selectedGroupField)" [title]="groupFieldPlaceholder(selectedGroupField)" [attr.aria-label]="groupFieldPlaceholder(selectedGroupField)" [attr.list]="groupSuggestions?.[selectedGroupField.formField.type] ? selectedGroupField.formField.type + '-list' : undefined">
          }
        </div>
      }
      @if (groupSuggestions?.[selectedGroupField.formField.type]) {
        <datalist [id]="selectedGroupField.formField.type + '-list'">
          @for (s of groupSuggestions?.[selectedGroupField.formField.type]; track s) {
            <option [value]="s">
              }
        </datalist>
      }
      @if (selectedGroupField.check) {
        <div class="small text-danger">
          {{selectedGroupField.check}}
        </div>
      }
    }
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="modal.close()" [disabled]="saving" class="btn btn-secondary btn-sm" type="button"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen</button>
  </div>
</ng-template>

<ng-template #ngSaveModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      @switch (process?.status) {
        @case (ProcessStatus.DRAFT) {Entwurf speichern}
        @case (ProcessStatus.SENT) {Antrag senden}
      }
    </h5>
  </div>
  <div class="modal-body p-3">
    @if (saving) {
      <div class="text-center m-auto">
        <rbb-loader/>
        <small class="text-secondary d-block">
          @switch (process?.status) {
            @case (ProcessStatus.DRAFT) {Entwurf wird gespeichert ...}
            @case (ProcessStatus.SENT) {Antrag wird gesendet ...}
          }
        </small>
      </div>
    }
    <div class="text-danger text-center m-auto">
      {{savingError}}
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="closeSaveModal()" [disabled]="saving" class="btn btn-secondary btn-sm" type="button"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen</button>
  </div>
</ng-template>
